import { ReactNode } from "react";

type MenuGroupType = ReactNode;
class MenuGroupFactoryType {
  menusForView: { [viewType: string]: { [key: string]: MenuGroupType } };
  constructor() {
    this.menusForView = {};
  }
  addMenuGroup(viewType: string, key: string, menuGroup: MenuGroupType) {
    if (!(viewType in this.menusForView)) {
      this.menusForView[viewType] = {};
    }
    if (key in this.menusForView[viewType]) {
      // only add once
      console.log("Multiple adds of ", key, "for", viewType, new Error().stack);
      return;
    }
    this.menusForView[viewType][key] = menuGroup;
  }
  getForView(viewType: string): MenuGroupType[] {
    return [...Object.values(this.menusForView[viewType] ?? {})]; // Return a copy to avoid leakage
  }
}
export const MenuGroupFactory = new MenuGroupFactoryType();
